import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "upload-progress-bar"
}
const _hoisted_2 = { class: "progress-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcProgressBar = _resolveComponent("NcProgressBar")!

  return (_ctx.processing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.progressNote), 1),
        _createVNode(_component_NcProgressBar, {
          value: _ctx.progress,
          error: _ctx.hasError
        }, null, 8, ["value", "error"])
      ]))
    : _createCommentVNode("", true)
}